export default "__VITE_ASSET__CRYs$M49__"